import type { Styles } from '@adornis/ass/style.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('ils-wifi-loader-animation')
export class ILSWifiLoaderAnimation extends ChemistryLitElement {
  override render() {
    return html`
      <div id="wifi-loader">
        <svg class="circle-outer" viewBox="0 0 86 86">
          <circle class="back" cx="43" cy="43" r="40"></circle>
          <circle class="front" cx="43" cy="43" r="40"></circle>
          <circle class="new" cx="43" cy="43" r="40"></circle>
        </svg>
        <svg class="circle-middle" viewBox="0 0 60 60">
          <circle class="back" cx="30" cy="30" r="27"></circle>
          <circle class="front" cx="30" cy="30" r="27"></circle>
        </svg>
        <svg class="circle-inner" viewBox="0 0 34 34">
          <circle class="back" cx="17" cy="17" r="14"></circle>
          <circle class="front" cx="17" cy="17" r="14"></circle>
        </svg>
      </div>
    `;
  }

  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        '#wifi-loader': {
          '--front-color': this.colors.accent,
          '--back-color': '#c3c8de',
          '--text-color': '#414856',
          width: '64px',
          height: '64px',
          'border-radius': '50px',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },

        '#wifi-loader svg': {
          position: 'absolute',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },

        '#wifi-loader svg circle': {
          position: 'absolute',
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          transform: 'rotate(-100deg)',
          transformOrigin: 'center',
          strokeWidth: '6px',
        },

        '#wifi-loader svg.circle-outer': {
          height: '86px',
          width: '86px',
        },

        '#wifi-loader svg circle.back': {
          stroke: 'var(--back-color)',
        },

        '#wifi-loader svg circle.front': {
          stroke: 'var(--front-color)',
        },

        '#wifi-loader svg.circle-outer circle': {
          strokeDasharray: '62.75 188.25',
        },

        '#wifi-loader svg.circle-outer circle.back': {
          animation: 'circle-outer 1.8s ease infinite 0.3s',
        },

        '#wifi-loader svg.circle-outer circle.front': {
          animation: 'circle-outer 1.8s ease infinite 0.15s',
        },

        '#wifi-loader svg.circle-middle': {
          height: '60px',
          width: '60px',
        },

        '#wifi-loader svg.circle-middle circle': {
          strokeDasharray: '42.5 127.5',
        },

        '#wifi-loader svg.circle-middle circle.back': {
          animation: 'circle-middle 1.8s ease infinite 0.25s',
        },

        '#wifi-loader svg.circle-middle circle.front': {
          animation: 'circle-middle 1.8s ease infinite 0.1s',
        },

        '#wifi-loader svg.circle-inner': {
          height: '34px',
          width: '34px',
        },

        '#wifi-loader svg.circle-inner circle': {
          strokeDasharray: '22 66',
        },

        '#wifi-loader svg.circle-inner circle.back': {
          animation: 'circle-inner 1.8s ease infinite 0.2s',
        },

        '#wifi-loader svg.circle-inner circle.front': {
          animation: 'circle-inner 1.8s ease infinite 0.05s',
        },

        '@keyframes circle-outer': {
          '0%': {
            strokeDashoffset: 25,
          },
          '25%': {
            strokeDashoffset: 0,
          },
          '65%': {
            strokeDashoffset: 301,
          },
          '80%': {
            strokeDashoffset: 276,
          },
          '100%': {
            strokeDashoffset: 276,
          },
        },

        '@keyframes circle-middle': {
          '0%': {
            strokeDashoffset: 17,
          },
          '25%': {
            strokeDashoffset: 0,
          },
          '65%': {
            strokeDashoffset: 204,
          },
          '80%': {
            strokeDashoffset: 187,
          },
          '100%': {
            strokeDashoffset: 187,
          },
        },

        '@keyframes circle-inner': {
          '0%': {
            strokeDashoffset: 9,
          },
          '25%': {
            strokeDashoffset: 0,
          },
          '65%': {
            strokeDashoffset: 106,
          },
          '80%': {
            strokeDashoffset: 97,
          },
          '100%': {
            strokeDashoffset: 97,
          },
        },
      },
    ];
  }
}
